import { createAsyncThunk, createSlice, PayloadAction } from '@reduxjs/toolkit';
import { RootState } from 'redux/store';

import { AppEnum, AppNameBannerMap } from '../../Types/enums';
import { LlmEnum } from '../../Types/llm';

interface AppStatusState {
  selectedApp: AppEnum;
  appName: string;
  llm: LlmEnum;
  drawerOpen: boolean;
  drawerWidth: string;
  folderListOpen: boolean;
  recentChatsOpen: boolean;
  isSwitchingApps: boolean;
}

const initialState: AppStatusState = {
  selectedApp: AppEnum.NIGEL,
  appName: AppNameBannerMap[AppEnum.NIGEL],
  llm: LlmEnum.GPT_41,
  drawerOpen: window.matchMedia('(min-width:1200px)').matches,
  drawerWidth: window.matchMedia('(min-width:1200px)').matches ? '350px' : '60px',
  folderListOpen: true,
  recentChatsOpen: true,
  isSwitchingApps: false,
};

const appStateSlice = createSlice({
  name: 'appStatus',
  initialState,
  reducers: {
    setCurrentApp: (state, action: PayloadAction<AppEnum>) => {
      state.selectedApp = action.payload;
      state.appName = AppNameBannerMap[action.payload];
    },
    setLLM: (state, action: PayloadAction<LlmEnum>) => {
      state.llm = action.payload;
    },
    setDrawerOpen: (state, action: PayloadAction<boolean>) => {
      state.drawerOpen = action.payload;
      state.drawerWidth = action.payload ? '350px' : '60px';
    },
    setFolderListOpen: (state, action: PayloadAction<boolean>) => {
      state.folderListOpen = action.payload;
    },
    setRecentChatsOpen: (state, action: PayloadAction<boolean>) => {
      state.recentChatsOpen = action.payload;
    },
    setIsSwitchingApps: (state, action: PayloadAction<boolean>) => {
      state.isSwitchingApps = action.payload;
    },
  },
});

export const {
  setCurrentApp,
  setLLM,
  setDrawerOpen,
  setFolderListOpen,
  setRecentChatsOpen,
  setIsSwitchingApps,
} = appStateSlice.actions;
// Async thunk to allow awaiting the app switch action
export const switchApp = createAsyncThunk<void, AppEnum>(
  'appStatus/switchApp',
  async (appName, { dispatch }) => {
    dispatch(setCurrentApp(appName));
  }
);

export const selectAppStatus = (state: RootState) => state.appStatus;

export default appStateSlice.reducer;
